<template>
  <div>
    <div class="nav-wrapper mr-b20">
      <el-row type="flex">
        <el-col class="item" style="background: #3e6279;">
          <span>(A) 응답시간: {{convertTimeFormat(responseTimeData.endUserResponseTime)}}</span>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="halfLeftSpan">
          <el-row type="flex">
            <el-col>
              <el-row type="flex">
                <el-col class="item" style="background: #316fbc;">
                  <span>(B) 초기 요청 반응 시간: {{convertTimeFormat(responseTimeData.firstByteTime)}}</span>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col class="item" style="background: #3291da;">
                  <span>(E) TCP 연결 시간: {{convertTimeFormat(responseTimeData.tcpConnectionTime)}}</span>
                </el-col>
                <el-col class="item" style="background: #369dde;">
                  <span>(F) 응답 가능 시간: {{convertTimeFormat(responseTimeData.responseAvailableTime)}}</span>
                </el-col>
              </el-row>
            </el-col>
            <el-col class="item double" style="background: #2493af;">
              <span>(C) HTML 다운로드 시간: {{convertTimeFormat(responseTimeData.htmlDownloadTime)}}</span>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col class="item" style="background: #6fbbdb;">
              <span>(G) DOM 준비 시간: {{convertTimeFormat(responseTimeData.domReadyTime)}}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="halfRightSpan">
          <el-row type="flex">
            <el-col class="item" style="background: #e37078;">
              <span>(D) 프론트엔드 시간: {{convertTimeFormat(responseTimeData.frontend)}}</span>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col class="item double" :span="domLeftSpan" style="background: #f8976d;">
              <span>(H) DOM 구성 시간: {{convertTimeFormat(responseTimeData.domBuildingTime)}}</span>
            </el-col>
            <el-col class="item double" :span="fetchRightSpan" style="background: #F3B16B;">
              <span>(I) 자원 패치 시간: {{convertTimeFormat(responseTimeData.resourceFetchTime)}}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-row type="flex" class="list form-list" :gutter="20">
      <el-col :span="12">
        <el-form :model="responseTimeData" label-width="180px" label-position="left">
          <el-form-item label="URI">{{ getValueAfterCheckEmpty(responseTimeData.uriText) }}</el-form-item>
          <el-form-item label="(A) 응답시간">{{ convertTimeFormat(responseTimeData.endUserResponseTime) }}</el-form-item>
          <el-form-item label="(C) HTML 다운로드 시간">{{ convertTimeFormat(responseTimeData.htmlDownloadTime) }}</el-form-item>
          <el-form-item label="(E) TCP 연결 시간">{{ convertTimeFormat(responseTimeData.tcpConnectionTime) }}</el-form-item>
          <el-form-item label="(G) DOM 준비 시간">{{ convertTimeFormat(responseTimeData.domReadyTime) }}</el-form-item>
          <el-form-item label="(I) 자원 패치 시간">{{ convertTimeFormat(responseTimeData.resourceFetchTime) }}</el-form-item>
          <el-form-item label="DNS 시간">{{ convertTimeFormat(responseTimeData.dnsTime) }}</el-form-item>
          <el-form-item label="총 페이지 로드 시간">{{ convertTimeFormat(responseTimeData.allPageLoadTime) }}</el-form-item>
          <!-- <el-form-item label="데이터 수신 (byte)">{{ checkEmptyData(responseTimeData.errorText) }}</el-form-item> -->
          <!-- <el-form-item label="Apdex">{{ checkEmptyData(responseTimeData.errorText) }}</el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form :model="responseTimeData" label-width="180px" label-position="left">
          <el-form-item label="시작 시간">{{ convertDateToString(responseTimeData.navigationStartTime) }}</el-form-item>
          <el-form-item label="(B) 초기 요청 반응 시간">{{ convertTimeFormat(responseTimeData.firstByteTime) }}</el-form-item>
          <el-form-item label="(D) 프론트엔드 시간">{{ convertTimeFormat(responseTimeData.frontend) }}</el-form-item>
          <el-form-item label="(F) 응답 가능 시간">{{ convertTimeFormat(responseTimeData.responseAvailableTime) }}</el-form-item>
          <el-form-item label="(H) DOM 구성 시간">{{ convertTimeFormat(responseTimeData.domBuildingTime) }}</el-form-item>
          <el-form-item label="네트워크 시간">{{ convertTimeFormat(responseTimeData.networkTime) }}</el-form-item>
          <el-form-item label="서버 시간">{{ convertTimeFormat(responseTimeData.serverTime) }}</el-form-item>
          <el-form-item label="호출 (건)">{{ convertNumberFormat(responseTimeData.count) }}</el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmpty as objectIsEmpty } from 'lodash';
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertThousandSeparatorFormat, convertMillisecondsToSeconds } from '@/utils/number';
import { getDateToString } from '@/utils/date';
import TransactionAPI from '@/api/apm/transaction';
import { GX_ID_STRING, OBJ_HASH } from '@/constants/apm-domain-define';

export default {
  name: 'WNavView',
  props: {
    activeTab: String, // 응답시간 탭 이름
    params: Object,
  },
  data() {
    return {
      responseTimeData: {},
      loading: false,
      halfLeftSpan: 12,
      halfRightSpan: 12,
      domLeftSpan: 12,
      fetchRightSpan: 12,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab() {
      this.loadData();
    },
    params() {
      this.loadData();
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    /**
     * 에러 데이터 호출
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.activeTab !== 'eumNav' || objectIsEmpty(this.params)) {
        return;
      }
      this.loading = true;
      const requestParam = {};
      requestParam[GX_ID_STRING] = this.params;
      requestParam[OBJ_HASH] = this.selectedNode.objHash;
      TransactionAPI.getDetailEumNav(requestParam).then((response) => {
        this.loading = false;
        if (response.data.success) {
          const result = response.data.data;
          this.responseTimeData = isEmpty(result) ? {} : result;
          this.calcSpanTime(result);
        } else {
          this.responseTimeData = {};
        }
      });
    },
    calcSpanTime(result) {
      if (!isEmpty(result)) {
        const twoColAllTime = Math.floor((result.domReadyTime + result.frontend) / 24);
        const halfIntwoColAllTime = Math.floor((result.domBuildingTime + result.resourceFetchTime) / 24);
        if (Math.floor(result.domReadyTime / twoColAllTime) > 14) {
          this.halfLeftSpan = 14;
        } else if (Math.floor(result.domReadyTime / twoColAllTime) < 10) {
          this.halfLeftSpan = 10;
        } else {
          this.halfLeftSpan = Math.floor(result.domReadyTime / twoColAllTime);
        }
        if (Math.floor(result.domBuildingTime / halfIntwoColAllTime) > 18) {
          this.domLeftSpan = 18;
        } else if (Math.floor(result.domBuildingTime / halfIntwoColAllTime) < 6) {
          this.domLeftSpan = 6;
        } else {
          this.domLeftSpan = Math.floor(result.domBuildingTime / halfIntwoColAllTime);
        }
        this.halfRightSpan = 24 - this.halfLeftSpan;
        this.fetchRightSpan = 24 - this.domLeftSpan;
      }
    },
    /**
     * date변환
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    convertDateToString(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
    },
    /**
     * 에러 수 천단위 환산
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    convertTimeFormat(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return convertMillisecondsToSeconds(value);
    },
    /**
     * 천단위 변환
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    convertNumberFormat(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return convertThousandSeparatorFormat(value);
    },
    /**
     * 필드 초기화
     * @author jda
     */
    reset() {
      this.responseTimeData = {};
    },
  },
};
</script>

<style lang="scss">
.nav-wrapper {
  width: 100%;

  .item {
    height: 30px;
    text-align: center;
    line-height: 30px;

    &.double {
      height: 60px;
      line-height: 60px;
    }

    span {
      color: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/NavView.vue